'use client'
import { VideoDialog } from 'components/VideoDialog'

export function VideoDialogClient({ content }) {
  return <VideoDialog content={content} />
}
